import React from 'react'
import { storiesOf } from '@storybook/react'

import QuizProgressBar from 'components/QuizProgressBar'

storiesOf('QuizProgressBar', module)
  .add('0% progress', () => (
    <QuizProgressBar
      answeredQuestions={0}
      currentQuestion={1}
      totalQuestions={3}
    />
  ))
  .add('25% progress', () => (
    <QuizProgressBar
      answeredQuestions={1}
      currentQuestion={2}
      totalQuestions={4}
    />
  ))
  .add('primary', () => (
    <QuizProgressBar
      color="primary"
      answeredQuestions={2}
      currentQuestion={2}
      totalQuestions={3}
    />
  ))
